import React from 'react'
import { UpgradeButton } from '@maui/freemium'

const REDACTED = 'redacted'

const onUpgradeClick = () => {
  window.location.href = '/upgrade'
}

const withFreemium = ({ prop, buttontext = 'Upgrade To View', layout = 'inline', href, Link, ...restProps }) => Component => {
  const WithFreemium = props => {
    if (typeof props[prop] === 'string' && props[prop].toLowerCase() === REDACTED) {
      return (
        <UpgradeButton onClick={onUpgradeClick} {...restProps}>{buttontext}</UpgradeButton>
      )
    }
    return <Component {...props} />
  }

  WithFreemium.displayName = Component.displayName
    ? `WithFreemium(${Component.displayName})`
    : 'WithFreemium'

  return WithFreemium
}

export default withFreemium
